import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {
  supplierShippingTerm: string;
  supplierShippingTermInstruction: string;
}

@Component({
  selector: 'app-shipment-terms-conditions',
  templateUrl: './shipment-terms-conditions.component.html',
  styleUrls: ['./shipment-terms-conditions.component.scss']
})
export class ShipmentTermsConditionsComponent implements OnInit {

  termsForm: FormGroup;
  partnerShipmentTerms:any;
  isSubmitted: boolean;

  constructor(
    private dialogref: MatDialogRef<ShipmentTermsConditionsComponent>,
    private toastr: ToastrService,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.termsForm = this._formBuilder.group({
      partnerShipmentTerms: [this.data.supplierShippingTerm, Validators.required],
      shipment_string:[this.data.supplierShippingTermInstruction],
    });

  }


  close() {
    this.dialogref.close();
  }


  submit() {
    this.isSubmitted = true;
    if (this.termsForm.invalid) {
      return false;
    } else {
    let formData = this.termsForm.get('partnerShipmentTerms').value
    let form = {
      "partnerShipmentTerms": formData,
      "supplierShippingTermInstruction": this.termsForm.get('shipment_string').value
    }
    console.log(this.termsForm);
    this.dialogref.close({data:form});
    // this.adminService.updateTermsConditions(form).subscribe(
    //   res => {
    //     this.toastr.success('Updated Terms & Conditions', 'Success');
    //     this.dialogref.close({data:form});
    //   },
    //   err => {
    //     this.toastr.error('Something Went Wrong', 'Error');
    //   }
    // )
    }

  }

  shippingTermList = ["Ex Works", "FOB", "FCA", "CIF", "DAP", "DPU", "DDP"];


}

